var _rect, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVertical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 65,
    viewBox: "0 0 127 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 126,
    width: 10,
    height: 102,
    rx: 2,
    transform: "rotate(90 126 0)",
    fill: "#7EA6FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 102,
    rx: 2,
    transform: "matrix(8.70218e-08 -1 -1 -2.19564e-08 126 64)",
    fill: "#F5F5F5",
    fillOpacity: 0.4,
    stroke: "#7EA6FF",
    strokeDasharray: "1 1"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 64,
    rx: 2,
    fill: "#4680FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVertical);
export default __webpack_public_path__ + "static/media/vertical.8e9ba87929c5906cb76ded307b6d4779.svg";
export { ForwardRef as ReactComponent };